<template>
    <div>
        <v-stepper v-model="currentStep_Id" v-if="!currentStep.hidden" alt-labels>
            <v-stepper-header class="elevation-15">
                <template v-for="(step,model) in activeSteps">
                    <v-stepper-step
                        :step="step._id||step.id"
                        :complete="step.success"
                        :rules="[() => !step.error]">
                        {{ step.name }}
                        <small>{{ step.error }}</small>
                    </v-stepper-step>
                    <v-divider v-if="model < (activeSteps.length -1)"></v-divider>
                </template>
            </v-stepper-header>
        </v-stepper>
        <div style="position: relative">
            <v-carousel v-model="currentStepIndex" hide-delimiters :show-arrows="false" height="auto" class="show-overflow" :touchless="true">
                <v-carousel-item
                    v-for="step in steps"
                    :key="'step_'+step.id"
                >
                    <component :is="step.component"></component>
                </v-carousel-item>
            </v-carousel>
        </div>
    </div>
</template>

<script>

export default {
    name    : "Stepper",
    computed: {
        currentStepId   : {
            get() {
                return this.$store.state.currentStepId;
            },
            set(n) {
                this.$store.commit('set_step_id', n);
            }
        },
        currentStep_Id   : {
            get() {
                return this.currentStep._id
            }
        },
        currentStepIndex: {
            get() {
                return this.$store.state.steps.findIndex(s => s.id === this.currentStepId);
            },
            set(n) {
                this.$store.commit('set_step_id', this.steps[n].id);
            }
        },
        steps() {
           let stepsList = this.$store.state.steps;
           if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_17') {
               if(this.$store.state.model.reservation._type=="advance" || this.$store.state.model.reservation.is_seasonal){
                   stepsList = stepsList.filter(s => !s.single_day_type);
               }
               stepsList = Object.assign( [], stepsList.filter(s => !s.multi_location_page));
           }else if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_12') {
               if(this.$store.state.model.reservation._type=="kiosk" || this.$store.state.model.reservation.is_seasonal){
                   stepsList = stepsList.filter(s => !s.single_day_type);
               }
               stepsList = Object.assign( [], stepsList.filter(s => !s.multi_location_page));
           }
           else if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_18') {
               if(this.$store.state.model.reservation._type=="advance" || this.$store.state.model.reservation.is_seasonal){
                   stepsList = stepsList.filter(s => !s.single_day_type);
               }
               stepsList = Object.assign( [], stepsList.filter(s => !s.multi_location_page));
           }else if(this.$store.state.resources.config.frontend_view_folder == 'frontend.skigd'){
               if(this.$store.state.model.reservation.is_seasonal){
                   stepsList = stepsList.filter(s => !s.single_day_type);
               }
               stepsList = Object.assign( [], stepsList.filter(s => !s.multi_location_page));
           }else{
               if((((this.$store.state.resources.config.module_type_enabled  && (this.$store.state.resources.config.module_type !== 'module_9' && this.$store.state.resources.config.module_type !== 'module_18')) &&( (this.$store.state.resources.config.module_type_enabled == 1 && (this.$store.state.resources.config.module_type!=='module_6' && this.$store.state.resources.config.module_type!=='module_5_2' && this.$store.state.resources.config.module_type!=='module_5_3') ))) && !this.$store.state.model.reservation.is_seasonal) || this.$store.state.model.reservation.is_seasonal || (this.$store.state.resources.config.module_type_enabled == 0) ){
                   stepsList = Object.assign( [], this.$store.state.steps.filter(s => !s.single_day_type));
               }
               if((this.$store.state.model.reservation._type==="advance" && (!parseInt(this.$store.state.resources.config.multi_location) || (parseInt(this.$store.state.resources.config.multi_location) && this.$store.state.resources.config.multi_location_list[1]['link']==null)) || window.location.href.includes('delivery'))){
                   stepsList = Object.assign( [], stepsList.filter(s => !s.multi_location_page));
               }else if(window.location.href.includes('seasonal') && (!parseInt(this.$store.state.resources.config.multi_location_for_seasonal) || (parseInt(this.$store.state.resources.config.multi_location_for_seasonal) && this.$store.state.resources.config.multi_location_list_for_seasonal[1]['link']==null))){
                   stepsList = Object.assign( [], stepsList.filter(s => !s.multi_location_page));
               }
           }
            if(!window.location.href.includes('delivery')){
                stepsList = stepsList.filter(s => !s.delivery_page)
            }
            if(window.location.href.includes('seasonal')){
                stepsList = stepsList.filter(s => !s.kiosk_step)
            }
            if((!window.location.href.includes('seasonal') && window.location.href.includes('kiosk')) || (window.location.href.includes('seasonal') &&  this.$store.state.resources.config.multi_location_for_seasonal==0)){
                 stepsList = Object.assign( [], stepsList.filter(s => !s.multi_location_page));
            }
            if(window.location.href.includes('prepay')){
                stepsList = parseInt(this.$store.state.resources.config.prepay_payment) || parseInt(this.$store.state.resources.config.only_save_card_at_prepay) ?  stepsList.filter(s => s.prepay_pay) : stepsList.filter(s => s.prepay_pay);
            }else{
                stepsList = stepsList.filter(s => !s.prepay_page)
            }
            return stepsList;
        },
        activeSteps(){
            return this.steps.filter(s => !s.hidden)
        },
        currentStep() {
            return this.steps[this.currentStepIndex];
        }

    }
}
</script>
<style>
.show-overflow{
    overflow: visible !important;
}
.v-window.show-overflow  .v-carousel__item{
    overflow: visible !important;
}
</style>
